import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../Modal';
import { dataContent } from './data';

interface TextInfoDialogInterface {
    onClose: Function;
    title: string;
}

export const TextInfoDialog: React.FC<TextInfoDialogInterface> = (props) => {
    const { t, i18n } = useTranslation();

    return (
        <Modal
            isOpen={!!props.title}
            onClose={props.onClose}
            title={props.title ? t(props.title) : ''}
            mode='head-colored'
            size='fit-content'
        >
            {props.title && <div dangerouslySetInnerHTML={{ __html: dataContent[props.title]?.[i18n.language] || '' }} />}
        </Modal>
    );
}
